import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('CompanyCreationContextResult', CompanyCreationContextResultData);

    CompanyCreationContextResultData.$inject = ['InvitedEntity'];

    /* @ngInject */
    function CompanyCreationContextResultData(InvitedEntity) {
        CompanyCreationContextResult.prototype = {
            build: build,
            getConfirmationMessage: getConfirmationMessage
        };

        function CompanyCreationContextResult(checkResultData) {
            this.build(checkResultData);
        }

        return CompanyCreationContextResult;

        function build(checkResultData) {
            this.constraint = checkResultData.constraint || null;
            this.invitedEntities = initInvitedEntities(checkResultData.invitedEntities);
        }

        function initInvitedEntities(invitedEntities) {
            let invitedEntitiesList = [];
            if (invitedEntities) {
                for (var s of invitedEntities) {
                    invitedEntitiesList.push(new InvitedEntity(s));
                }
            }
            return invitedEntitiesList;
        }

        function getConfirmationMessage() {
            let message = [];
            let invitedEntities = this.invitedEntities;
            let constraint = this.constraint;
            switch (constraint) {
                case 'FULL_MATCHING_ENTITY': // DDO-R52
                    message = [
                        {
                            key: 'principal.companies_details.create.' + angular.lowercase(constraint)
                        }
                    ];
                    break;
                case 'FISCAL_MATCHING_LEGAL_TO_CONFIRM_ENTITY': // DDO-R53
                case 'LEGAL_MATCHING_FISCAL_MISSING_ENTITY': // DDO-R56
                    _addLegalMatchingFiscalMissingInvitedEntityMessage(message, invitedEntities, constraint);
                    break;
                case 'LEGAL_MATCHING_FISCAL_TO_CONFIRM_ENTITY': // DDO-R54
                case 'FISCAL_MATCHING_LEGAL_MISSING_ENTITY': // DDO-R55
                    _addFiscalMatchingLegalMissingInvitedEntityMessage(message, invitedEntities, constraint);
                    break;
                case 'ACTIVE_AND_PENDING_MATCHING_INVITED_ENTITIES': // DDO-R58
                    _addActivePendingInvitedEntitiesMessage(message, invitedEntities, constraint);
                    break;
                case 'PENDING_AND_ACTIVE_MATCHING_INVITED_ENTITIES': // DDO-R59
                    _addPendingActiveInvitedEntitiesMessage(message, invitedEntities, constraint);
                    break;
                case 'PENDING_MATCHING_INVITED_ENTITIES': // DDO-R60
                    _addPendingInvitedEntitiesMessage(message, invitedEntities, constraint);
                    break;
                case 'INCOHERENT_PENDING_MATCHING_INVITED_ENTITIES': // DDO-R61
                    _addIncoherentPendingInvitedEntitiesMessage(message, invitedEntities, constraint);
                    break;
                case 'INCOHERENT_PENDING_AND_ACTIVE_MATCHING_INVITED_ENTITIES': // DDO-R64
                    _addIncoherentPendingActiveInvitedEntitiesMessage(message, invitedEntities, constraint);
                    break;
                default:
                    break;
            }
            return message;
        }

        function _addLegalMatchingFiscalMissingInvitedEntityMessage(message, invitedEntities, constraint) {
            if (invitedEntities && invitedEntities.length > 0 && invitedEntities[0].legalEntity) {
                message.push({
                    key: 'principal.companies_details.create.' + angular.lowercase(constraint),
                    values: {
                        idNationalKind: invitedEntities[0].legalEntity.getNationalKindLabel(),
                        idNational: invitedEntities[0].legalEntity.idNational
                    }
                });
            }
        }

        function _addFiscalMatchingLegalMissingInvitedEntityMessage(message, invitedEntities, constraint) {
            if (invitedEntities && invitedEntities.length > 0 && invitedEntities[0].legalEntity) {
                message.push({
                    key: 'principal.companies_details.create.' + angular.lowercase(constraint),
                    values: {
                        idFiscalKind: invitedEntities[0].legalEntity.getFiscalKindLabel(),
                        idFiscal: invitedEntities[0].legalEntity.idFiscal
                    }
                });
            }
        }

        function _addActivePendingInvitedEntitiesMessage(message, invitedEntities, constraint) {
            if (invitedEntities && invitedEntities.length >= 2) {
                message.push({
                    key: 'principal.companies_details.create.' + angular.lowercase(constraint),
                    values: {
                        idFiscalKind: _getActiveEntity(invitedEntities).legalEntity.getFiscalKindLabel(),
                        idFiscal: _getActiveEntity(invitedEntities).legalEntity.idFiscal,
                        idNationalKind: _getPendingEntity(invitedEntities).legalEntity.getNationalKindLabel(),
                        idNational: _getPendingEntity(invitedEntities).legalEntity.idNational
                    }
                });
            }
        }

        function _addPendingActiveInvitedEntitiesMessage(message, invitedEntities, constraint) {
            if (invitedEntities && invitedEntities.length >= 2) {
                message.push({
                    key: 'principal.companies_details.create.' + angular.lowercase(constraint),
                    values: {
                        idFiscalKind: _getPendingEntity(invitedEntities).legalEntity.getFiscalKindLabel(),
                        idFiscal: _getPendingEntity(invitedEntities).legalEntity.idFiscal,
                        idNationalKind: _getActiveEntity(invitedEntities).legalEntity.getNationalKindLabel(),
                        idNational: _getActiveEntity(invitedEntities).legalEntity.idNational
                    }
                });
            }
        }

        function _addPendingInvitedEntitiesMessage(message, invitedEntities, constraint) {
            if (invitedEntities && invitedEntities.length >= 2) {
                message.push({
                    key: 'principal.companies_details.create.' + angular.lowercase(constraint),
                    values: {
                        idFiscalKind: _getEntityHavingFiscal(invitedEntities).legalEntity.getFiscalKindLabel(),
                        idFiscal: _getEntityHavingFiscal(invitedEntities).legalEntity.idFiscal,
                        idNationalKind: _getEntityHavingNational(invitedEntities).legalEntity.getNationalKindLabel(),
                        idNational: _getEntityHavingNational(invitedEntities).legalEntity.idNational
                    }
                });
            }
        }

        function _addIncoherentPendingActiveInvitedEntitiesMessage(message, invitedEntities, constraint) {
            if (invitedEntities && invitedEntities.length > 0) {
                let pendingSeller = _getPendingEntities(invitedEntities);
                let activeSeller = _getActiveEntity(invitedEntities);
                message.push({
                    key: 'principal.companies_details.create.' + angular.lowercase(constraint) + '_1'
                });
                for (let s of pendingSeller) {
                    message.push({
                        key: 'principal.companies_details.create.' + angular.lowercase(constraint) + '_item',
                        values: {
                            country: s.legalEntity.getCountryLabel(),
                            idFiscalKind: s.legalEntity.getFiscalKindLabel(),
                            idFiscal: s.legalEntity.idFiscal,
                            idNationalKind: s.legalEntity.getNationalKindLabel(),
                            idNational: s.legalEntity.idNational
                        }
                    });
                }
                message.push({
                    key: 'principal.companies_details.create.' + angular.lowercase(constraint) + '_2',
                    values: {
                        idFiscalKind: activeSeller.legalEntity.getFiscalKindLabel(),
                        idFiscal: activeSeller.legalEntity.idFiscal,
                        idNationalKind: activeSeller.legalEntity.getNationalKindLabel(),
                        idNational: activeSeller.legalEntity.idNational
                    }
                });
            }
        }

        function _addIncoherentPendingInvitedEntitiesMessage(message, invitedEntities, constraint) {
            if (invitedEntities && invitedEntities.length > 0) {
                message.push({
                    key: 'principal.companies_details.create.' + angular.lowercase(constraint) + '_1'
                });
                for (let s of invitedEntities) {
                    message.push({
                        key: 'principal.companies_details.create.' + angular.lowercase(constraint) + '_item',
                        values: {
                            country: s.legalEntity.getCountryLabel(),
                            idFiscalKind: s.legalEntity.getFiscalKindLabel(),
                            idFiscal: s.legalEntity.idFiscal,
                            idNationalKind: s.legalEntity.getNationalKindLabel(),
                            idNational: s.legalEntity.idNational
                        }
                    });
                }
                message.push({
                    key: 'principal.companies_details.create.' + angular.lowercase(constraint) + '_2'
                });
            }
        }

        function _getActiveEntity(invitedEntities) {
            let activeEntity = null;
            if (invitedEntities) {
                activeEntity = _.find(invitedEntities, invitedEntity => invitedEntity.isActive());
            }
            return activeEntity;
        }

        function _getPendingEntity(invitedEntities) {
            let pendingEntity = null;
            if (invitedEntities) {
                pendingEntity = _.find(invitedEntities, invitedEntity => invitedEntity.isCreated() || invitedEntity.isNotified());
            }
            return pendingEntity;
        }

        function _getPendingEntities(invitedEntities) {
            let pendingEntities = null;
            if (invitedEntities) {
                pendingEntities = _.filter(invitedEntities, seller => seller.isCreated() || seller.isNotified());
            }
            return pendingEntities;
        }

        function _getEntityHavingFiscal(invitedEntities) {
            let entityHavingFiscal = null;
            if (invitedEntities) {
                entityHavingFiscal = _.find(invitedEntities, invitedEntity => invitedEntity.legalEntity.idFiscal);
            }
            return entityHavingFiscal;
        }

        function _getEntityHavingNational(invitedEntities) {
            let entityHavingNational = null;
            if (invitedEntities) {
                entityHavingNational = _.find(invitedEntities, invitedEntity => invitedEntity.legalEntity.idNational);
            }
            return entityHavingNational;
        }
    }
})();
